import React, { Component, createRef } from "react";
import { CanvasContext } from "../../Context";
import { isTextComponent } from "../Left";
import ContextMenu from "./ContextMenu";
import styles from "./index.less";
import Lines from "./Lines";
import Rotate from "./Rotate";
import StretchDots from "./StretchDots";

export default class EditLine extends Component {
  static contextType = CanvasContext;

  constructor(props) {
    super(props);
    this.state = {
      showContextMenu: false,
      textareaFocused: false,
    };
    this.textareaRef = createRef();
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    if (
      prevProps.selectedIndex !== this.props.selectedIndex &&
      this.state.showContextMenu
    ) {
      this.hideShowContextMenu();
    }
  }

  onMouseDownOfCmp = (e) => {
    if (this.state.textareaFocused) {
      return;
    }
    e.preventDefault();

    let startX = e.pageX;
    let startY = e.pageY;

    const { zoom } = this.props;
    const move = (e) => {
      const x = e.pageX;
      const y = e.pageY;

      let disX = x - startX;
      let disY = y - startY;

      disX = disX * (100 / zoom);
      disY = disY * (100 / zoom);

      this.context.updateAssemblyCmps({ top: disY, left: disX });

      startX = x;
      startY = y;
    };

    const up = () => {
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", up);
      this.context.recordCanvasChangeHistory();
    };
    document.addEventListener("mousemove", move);
    document.addEventListener("mouseup", up);
  };

  valueChange = (e) => {
    const newValue = e.target.value;
    const textHeight = this.textareaRef.current.scrollHeight;
    this.context.updateSelectedCmp({ height: textHeight }, newValue);
    this.context.recordCanvasChangeHistory();
  };

  handleShowContextMenu = (e) => {
    e.preventDefault();
    this.setState({
      showContextMenu: true,
    });
  };

  hideShowContextMenu = (e) => {
    this.setState({
      showContextMenu: false,
    });
  };

  render() {
    const { zoom } = this.props;
    const cmp = this.context.getSelectedCmp();
    if (!cmp) {
      return null;
    }

    // eslint-disable-next-line no-unused-vars
    const { style, value } = cmp;

    const { width, height } = style;
    const transform = `rotate(${style.transform}deg)`;
    return (
      <div
        className={styles.main}
        style={{
          zIndex: 99999,
          width,
          height,
          top: style.top,
          left: style.left,
          transform,
        }}
        onDoubleClick={(e) => {
          this.setState({
            textareaFocused: true,
            showContextMenu: false,
          });
        }}
      >
        {cmp.type === isTextComponent && this.state.textareaFocused ? (
          <textarea
            ref={this.textareaRef}
            value={cmp.value}
            onChange={this.valueChange}
            onBlur={() => {
              this.setState({ textareaFocused: false });
            }}
            style={{
              ...style,
              width,
              height,
              top: 0,
              left: 0,
            }}
          />
        ) : (
          <div
            className={styles.eventMask}
            style={{
              width,
              height,
            }}
            onMouseDown={this.onMouseDownOfCmp}
            onContextMenu={this.handleShowContextMenu}
          ></div>
        )}

        {this.state.showContextMenu && (
          <ContextMenu
            style={{
              top: 2,
              left: width / 2,
              transform: `scale(${100 / zoom}) rotate(${
                0 - style.transform
              }deg)`,
            }}
          />
        )}

        <Lines style={{ width, height }} />

        <StretchDots
          zoom={zoom}
          style={{
            width,
            height,
            transform: `scale(${100 / zoom})`,
          }}
        />

        <Rotate
          zoom={zoom}
          style={{ width, height, transform: `scale(${100 / zoom})` }}
        />
      </div>
    );
  }
}
